import script from "./PortalAppsSection.vue?vue&type=script&setup=true&lang=js"
export * from "./PortalAppsSection.vue?vue&type=script&setup=true&lang=js"

import "./PortalAppsSection.vue?vue&type=style&index=0&id=15057142&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15057142"]])

export default __exports__